import { Loader2 } from 'lucide-react';

/** Full-screen branded splash — Quantora logo + loader + ISO strap. */
export const SplashScreen = ({ message = 'Loading your workspace…' }) => (
  <div
    className="fixed inset-0 z-[9999] bg-gradient-to-br from-[#050914] via-[#0A0E1A] to-[#0F1A2E] flex flex-col items-center justify-center text-white"
    data-testid="splash-screen"
  >
    {/* Soft glow */}
    <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-72 h-72 rounded-full bg-emerald-500/20 blur-[120px] animate-pulse" />
    <div className="relative flex flex-col items-center">
      <div className="relative">
        <img
          src="/quantora-logo.png"
          alt="Quantora"
          className="w-24 h-24 object-contain animate-splash-pulse"
          style={{ animation: 'splashPulse 1.6s ease-in-out infinite' }}
        />
      </div>
      <h1 className="mt-5 font-heading text-xl font-bold tracking-wide">QUANTORA</h1>
      <p className="text-[10px] text-emerald-300/80 tracking-[0.3em] uppercase mt-1">Market Advisory</p>

      <div className="mt-7 flex items-center gap-2 text-xs text-white/60">
        <Loader2 size={14} className="animate-spin text-emerald-400" />
        {message}
      </div>
    </div>

    <style>{`
      @keyframes splashPulse {
        0%, 100% { transform: scale(1); filter: drop-shadow(0 0 0 rgba(16,185,129,0.0)); }
        50%      { transform: scale(1.05); filter: drop-shadow(0 0 24px rgba(16,185,129,0.5)); }
      }
    `}</style>
  </div>
);
